import { testPlainObjectOrPrimitive } from "@ixfx/guards";
export const cloneFromFields = (source) => {
    const entries = [];
    for (const field in source) {
        const value = (source)[field];
        if (testPlainObjectOrPrimitive(value)) {
            entries.push([field, value]);
        }
    }
    return Object.fromEntries(entries);
};
